import { render } from "./Index.vue?vue&type=template&id=8f8a6876&ts=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Companies/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f8a6876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f8a6876', __exports__)) {
    console.log('reload')
    api.reload('8f8a6876', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=8f8a6876&ts=true", () => {
    console.log('re-render')
    api.rerender('8f8a6876', render)
  })

}


export default __exports__